import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Dejás de perder plantas por errores evitables', 'Actuás con seguridad en cada etapa', 'Ahorrás tiempo, frustración y dinero', 'Sumás una habilidad que usás toda la vida'];
  return <section className="py-16 md:py-24 bg-white" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-4" data-id="element-4">
            🌱 Qué cambia para vos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-5">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 bg-[#fafaf9] rounded-2xl border border-gray-100 hover:border-[#4a7c2c] transition-colors" data-id="element-6">
              <div className="bg-[#4a7c2c] rounded-full p-1 shrink-0 mt-1" data-id="element-7">
                <Check className="w-4 h-4 text-white" data-id="element-8" />
              </div>
              <p className="text-lg text-[#1a1a1a] font-medium" data-id="element-9">{benefit}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}